export type SiteConfigInput = Partial<{
  purchaseUrl: unknown;
  downloadUrl: unknown;
  version: unknown;
  installerSize: unknown;
  priceRub: unknown;
}>;

export type SiteConfig = {
  purchaseUrl: string;
  downloadUrl: string;
  version: string;
  installerSize: string;
  priceRub: number;
};

export const DEFAULT_SITE_CONFIG: SiteConfig = {
  purchaseUrl: "",
  downloadUrl: "/downloads/NordTalk_0.5.0_x64-setup.exe",
  version: "0.5.0",
  installerSize: "157,01 MiB",
  priceRub: 2500,
};

const cleanString = (value: unknown, fallback: string, maxLength: number) => {
  if (typeof value !== "string") return fallback;
  const cleaned = value.trim();
  return cleaned && cleaned.length <= maxLength ? cleaned : fallback;
};

export const normalizeSiteConfig = (input?: SiteConfigInput): SiteConfig => {
  const price =
    typeof input?.priceRub === "number" &&
    Number.isInteger(input.priceRub) &&
    input.priceRub > 0 &&
    input.priceRub < 1_000_000
      ? input.priceRub
      : DEFAULT_SITE_CONFIG.priceRub;

  return {
    purchaseUrl: cleanString(input?.purchaseUrl, "", 2048),
    downloadUrl: cleanString(
      input?.downloadUrl,
      DEFAULT_SITE_CONFIG.downloadUrl,
      2048,
    ),
    version: cleanString(input?.version, DEFAULT_SITE_CONFIG.version, 32),
    installerSize: cleanString(
      input?.installerSize,
      DEFAULT_SITE_CONFIG.installerSize,
      64,
    ),
    priceRub: price,
  };
};

export const safeDestination = (
  value: string,
  origin: string,
): string | null => {
  if (!value.trim()) return null;
  try {
    const destination = new URL(value, origin);
    return destination.protocol === "http:" || destination.protocol === "https:"
      ? destination.href
      : null;
  } catch {
    return null;
  }
};

export const formatPrice = (priceRub: number) =>
  new Intl.NumberFormat("ru-RU").format(priceRub);
